import type { Pagination, ServingContainer } from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'core/serving-containers';

export function getServingContainers(query?: ServingContainer.SearchQuery) {
    return api.get<Pagination<ServingContainer>>(rootPath, query);
}

export function getServingContainer(id: number) {
    return api.get<ServingContainer.DetailsResponse>(
        `${rootPath}/${id}`,
        undefined
    );
}

export function postServingContainer(data: ServingContainer.CreateRequest) {
    return api.post<ServingContainer>(rootPath, data);
}

export function putServingContainer(
    id: number,
    data: ServingContainer.UpdateRequest
) {
    return api.put<ServingContainer>(`${rootPath}/${id}`, data);
}

export function deleteServingContainer({ id }: ServingContainer.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
